<template>
  <v-container fluid>
    <h2 class="mt-2 mb-2">{{ $t('Users management') }}</h2>

    <!-- <v-layout wrap>
      <v-flex xs12 :sm6="selectedGroup" class="pa-1">
        <v-layout class="mb-2">
          <v-flex>
            <h2 class="title grey--text mt-2">Group</h2>
          </v-flex>
          <add-admin-group @addGroup="addGroup"></add-admin-group>
        </v-layout>

        <template v-if="groups && groups.length > 0">
          <v-card>
            <template v-for="(group, gindex) in groups">
              <div class="pa-3" :key="`group_${group.id}`">
                <v-layout>
                  <v-flex>
                    <div class="font-weight-bold">
                      {{ group.groupname }}
                    </div>
                    <div class="caption">
                      {{ group.groupdescription ? group.groupdescription : '&nbsp;' }}
                    </div>
                  </v-flex>
                  <edit-admin-group
                    v-model="groups[gindex]"
                    @editGroup="editGroup"
                    :key="'group_' + group.id + '_' + gindex"
                  ></edit-admin-group>

                  <v-btn
                    fab
                    small
                    color="primary"
                    outline
                    class="mx-1 my-0"
                    @click="onDeleteGroup(group)"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>

                  <v-icon class="mt-2 ml-2" style="cursor: pointer" @click="selectedGroup = group">
                    arrow_forward_ios
                  </v-icon>
                </v-layout>
              </div>
              <v-divider :key="`group_divider_${group.id}`" v-if="groups.length - 1 != gindex" />
            </template>
          </v-card>
        </template>
        <div v-else class="text-xs-center grey lighten-3 py-3" style="border-radius: 10px">
          No data available
        </div>
      </v-flex>
      <v-flex xs12 :sm6="selectedGroup" class="pa-1" v-if="selectedGroup">
        <v-layout class="mb-2">
          <v-flex>
            <h2 class="title grey--text mt-2">{{ selectedGroup.groupname }} Group</h2>
          </v-flex>
          <add-admin-sub-group
            :group="selectedGroup"
            @addSubGroup="addSubGroup"
          ></add-admin-sub-group>
        </v-layout>

        <template v-if="filterSubGroups && filterSubGroups.length > 0">
          <v-card>
            <template v-for="(subgroup, gindex) in filterSubGroups">
              <div class="pa-3" :key="`group_${subgroup.id}`">
                <v-layout>
                  <v-flex>
                    <div class="font-weight-bold">
                      {{ subgroup.subgroupname }}
                    </div>
                    <div class="caption">
                      {{ subgroup.subgroupdescription ? subgroup.subgroupdescription : '&nbsp;' }}
                    </div>
                  </v-flex>
                  <edit-admin-sub-group
                    :group="selectedGroup"
                    v-model="filterSubGroups[gindex]"
                    @editSubGroup="editSubGroup"
                  ></edit-admin-sub-group>

                  <v-btn
                    fab
                    small
                    color="primary"
                    outline
                    class="mx-1 my-0"
                    @click="onDeleteSubGroup(subgroup)"
                    ><v-icon>delete</v-icon></v-btn
                  >
                </v-layout>
              </div>
              <v-divider
                :key="`group_divider_${subgroup.id}`"
                v-if="filterSubGroups.length - 1 != gindex"
              />
            </template>
          </v-card>
        </template>
        <div v-else class="text-xs-center grey lighten-3 py-3" style="border-radius: 10px">
          No data available
        </div>
      </v-flex>
    </v-layout> -->

    <div class="pa-1 mt-4">
      <v-layout class="mb-2">
        <v-flex>
          <!-- <h3 class="grey--text mt-2">Admin Users</h3> -->
        </v-flex>
        <add-user @addUser="onAddUser"></add-user>
      </v-layout>
      <div v-if="loading" class="spinner text-xs-center mt-5">
        <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
      </div>

      <v-data-table
        v-else
        :headers="headers"
        :pagination.sync="pagination"
        :items="admins"
        class="elevation-1"
        hide-actions
      >
        <template v-slot:items="props">
          <td>{{ props.index + 1 }}</td>
          <td>{{ props.item.adminid }}</td>
          <td>
            <template>
              <change-password :userid="props.item.adminid"></change-password>
            </template>
          </td>
          <td>
            <!-- <template>
              <edit-user
                :key="props.index + '_' + props.item.adminid"
                v-model="props.item"
                @editUser="onEditUser"
              ></edit-user>
            </template> -->
            <v-btn fab small outline color="primary" @click="onDeleteUser(props.item)"
              ><v-icon>delete</v-icon></v-btn
            >

            <!-- <toggle-button
              :value="props.item.assign_status"
              :sync="true"
              @change="
                putassignstatusByadminid(props.item.adminid, props.item.assign_status)
                props.item.assign_status = !props.item.assign_status
              "
              :color="$vuetify.theme.success"
              :labels="{ checked: 'ON', unchecked: 'OFF' }"
            /> -->
          </td>
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
// const AddAdminGroup = () => import('./AddAdminGroup')
// const EditAdminGroup = () => import('./EditAdminGroup')
// const AddAdminSubGroup = () => import('./AddAdminSubGroup')
// const EditAdminSubGroup = () => import('./EditAdminSubGroup')
const ChangePassword = () => import('./ChangePassword')
const AddUser = () => import('./AddUser')

const EditUser = () => import('./EditUser')
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
      // loadingAgentGroup: 'getLoadingAgentGroup',
      // loadingAgentSubGroup: 'getLoadingAgentSubgroup'
    }),
    // filterSubGroups() {
    //   if (this.selectedGroup) {
    //     return this.subgroups.filter(el => {
    //       return el.admingroupid == this.selectedGroup.id
    //     })
    //   }
    //   return []
    // },
    com7pageid() {
      let pageid =
        selectedBot.theme === 'ustore' ? selectedBot.pageid : this.$store.state.com7pages[0].pageid
      return pageid
    }
  },
  components: {
    // AddAdminGroup,
    // EditAdminGroup,
    // AddAdminSubGroup,
    // EditAdminSubGroup,
    ChangePassword,
    AddUser,
    EditUser,
    ToggleButton
  },
  data() {
    return {
      loading: false,
      adminloading: [],
      admins: [],
      // groups: [],
      // subgroups: [],
      pagination: {
        rowsPerPage: 999
      },
      headers: [
        { text: this.$t('No.'), value: this.$t('index') },
        { text: this.$t('Username') },
        { text: this.$t('Password') },
        { text: this.$t('Action') }
      ],
      selectedGroup: null
    }
  },
  async mounted() {
    this.loading = true
    try {
      // var responseGroup = await this.getAdminGroup()
      // var responseSubGroup = await this.getAdminSubGroup()
      var responseAdmin = await this.getAdmins()
      // if (responseGroup.data) {
      //   this.groups = responseGroup.data
      //   this.$store.state.agentGroups = this.groups
      // }
      // if (responseSubGroup.data) {
      //   this.subgroups = responseSubGroup.data
      //   this.$store.state.agentSubgroups = this.subgroups
      // }
      if (responseAdmin) {
        this.admins = responseAdmin
      }
    } catch (error) {
      console.error(error)
    }
    this.loading = false
  },
  methods: {
    putassignstatusByadminid(adminid, status) {
      var vm = this
      var data = {
        pageid: this.selectedBot.pageid,
        assign_status: !status,
        userid: adminid
      }
      this.adminloading.push(adminid)
      api.putassignstatusByadminid(data, (err, response) => {
        if (response.responsecode == 200) {
          var index = vm.adminloading.findIndex(el => el == adminid)
          vm.adminloading.splice(index, 1)
          status = !status
        }
      })
    },
    async onAddUser(user) {
      this.$store.dispatch('loadAgents')
      var responseAdmin = await this.getAdmins()
      if (responseAdmin) {
        this.admins = responseAdmin
      }
    },
    async onEditUser(user) {
      this.$store.dispatch('loadAgents')
      var responseAdmin = await this.getAdmins()
      if (responseAdmin) {
        this.admins = responseAdmin
      }
    },
    async getAdmins() {
      var data = {
        pageid: this.selectedBot.pageid
      }
      var res = await api.getAdmins(data)
      if (res.success) {
        return res.result
      }
    },
    // getAdminGroup() {
    //   var data = {
    //     pageid: this.selectedBot.pageid
    //   }
    //   return new Promise((resolve, reject) => {
    //     api.getAdminGroup(data, (error, response) => {
    //       if (error) {
    //         console.error(error)
    //         reject(error)
    //       }
    //       resolve(response)
    //     })
    //   })
    // },
    // getAdminSubGroup() {
    //   var data = {
    //     pageid: this.selectedBot.pageid
    //   }
    //   return new Promise((resolve, reject) => {
    //     api.getAdminSubGroup(data, (error, response) => {
    //       if (error) {
    //         console.error(error)
    //         reject(error)
    //       }
    //       resolve(response)
    //     })
    //   })
    // },
    // addGroup(payload) {
    //   this.groups.push(payload)
    //   this.$store.dispatch('loadAgentGroups')
    // },
    // editGroup(payload) {
    //   var index = this.groups.findIndex(el => {
    //     return el.id == payload.id
    //   })
    //   if (index != -1) {
    //     this.$set(this.groups, index, payload)
    //   }
    //   this.$store.dispatch('loadAgentGroups')
    // },
    // async onDeleteGroup(group) {
    //   var result = await this.$swal.fire({
    //     title: this.$t('Do you want to delete {name}?', {
    //       name: group.groupname.replace(/\<|\>/g, '')
    //     }),
    //     type: 'warning',
    //     confirmButtonText: this.$t('Confirm'),
    //     cancelButtonText: this.$t('cancel'),
    //     reverseButtons: true,
    //     showCancelButton: true
    //   })
    //   if (result.value) {
    //     await this.deleteGroup(group)
    //     var index = this.groups.findIndex(el => {
    //       return el.id == group.id
    //     })
    //     if (index != -1) {
    //       this.groups.splice(index, 1)
    //       this.$store.dispatch('loadAgentGroups')
    //     }
    //   }
    // },
    // deleteGroup(data) {
    //   return new Promise((resolve, reject) => {
    //     var request = {
    //       id: data.id,
    //       pageid: this.selectedBot.pageid
    //     }
    //     api.deleteadmingroup(request, function(error, response) {
    //       if (error) {
    //         reject(error)
    //       }
    //       resolve(response)
    //     })
    //   })
    // },
    // addSubGroup(payload) {
    //   this.subgroups.push(payload)
    //   this.$store.dispatch('loadAgentSubGroups')
    // },
    // editSubGroup(payload) {
    //   var index = this.subgroups.findIndex(el => {
    //     return el.id == payload.id
    //   })
    //   if (index != -1) {
    //     this.$set(this.subgroups, index, payload)
    //   }
    //   this.$store.dispatch('loadAgentSubGroups')
    // },
    // async onDeleteSubGroup(group) {
    //   var result = await this.$swal.fire({
    //     title: this.$t('Do you want to delete {name}?', {
    //       name: group.subgroupname.replace(/\<|\>/g, '')
    //     }),
    //     type: 'warning',
    //     confirmButtonText: this.$t('Confirm'),
    //     cancelButtonText: this.$t('cancel'),
    //     reverseButtons: true,
    //     showCancelButton: true
    //   })
    //   if (result.value) {
    //     await this.deleteSubGroup(group)
    //     var index = this.subgroups.findIndex(el => {
    //       return el.id == group.id
    //     })
    //     if (index != -1) {
    //       this.subgroups.splice(index, 1)
    //       this.$store.dispatch('loadAgentSubGroups')
    //     }
    //   }
    // },
    // deleteSubGroup(data) {
    //   return new Promise((resolve, reject) => {
    //     var request = {
    //       id: data.id,
    //       pageid: this.selectedBot.pageid
    //     }
    //     api.deleteadminsubgroup(request, function(error, response) {
    //       if (error) {
    //         reject(error)
    //       }
    //       resolve(response)
    //     })
    //   })
    // },
    async onDeleteUser(user) {
      var result = await this.$swal.fire({
        title: this.$t('Do you want to delete {name}?', {
          name: user.adminid.replace(/\<|\>/g, '')
        }),
        type: 'warning',
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true,
        showCancelButton: true
      })
      if (result.value) {
        this.$store.dispatch('loading')
        await this.deleteadminusers({ userid: user.adminid })
        var responseAdmin = await this.getAdmins()
        if (responseAdmin) {
          this.admins = responseAdmin
        }
        this.$store.dispatch('loading')
      }
    },
    async deleteadminusers(data) {
      // return new Promise((resolve, reject) => {
      var request = {
        userid: data.userid,
        pageid: this.selectedBot.pageid
      }
      var res = await api.deleteadminusers(request)
      if (res.success) {
        return res.result
      }
      //   api.deleteadminusers(request, function(error, response) {
      //     if (error) {
      //       reject(error)
      //     }
      //     resolve(response)
      //   })
      // })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/Agentmanagement/Users.vue